<template>
  <navigation_back class="mb-2"/>
  <div v-if="loading" class="flex w-min p-2 bg-blue-300 rounded-md ">
    Loading
  </div>
  <div v-else class="p-4 bg-white rounded-md">
    <div><span class="font-semibold">Subject: </span><span>{{ event_data?.event_data?.subject }}</span></div>
    <div><span class="font-semibold">Date: </span>{{event_data?.event_data?.start?.dateTime}}</div>
    <div class="font-semibold">Online Meetings:</div>
    <div v-for="onlineMeeting in event_data.online_meeting_data" :key="onlineMeeting" class="border rounded-md"  >
      <div><span class="font-semibold">Attendance Summary:</span><span>{{ onlineMeeting.attendance_summary }}</span></div>
      <div><span class="font-semibold">Transcript success:</span>{{onlineMeeting.transcript_available}}</div>
      <div><span class="font-semibold">Transcript:</span><span>{{ onlineMeeting.transcript }}</span></div>
    </div>
  </div>

</template>

<script>

import axios from 'axios'
import router from '../../../router'
import navigation_back from '@/components/widgetcomponents/navigation_back.vue';

export default {
  components: {
    navigation_back
  },
  props:{
    meetingId:{
      type:String,
      required:true
    },
    appuserId:{
      type:Number,
      required:true
    }
  },
  data() {
    return {
      event_data:{},
      loading:true
    }
  },
  computed:{

  },
  methods: {
    fetchEventDetails() {
      axios.get('/api/microsoftteams/meetings/',{
        params:{
          appuser_id:this.appuserId,
          event_id:this.meetingId
        }
      })
        .then(response => {
          this.event_data = response.data // Assuming the response contains the location details
          this.loading=false
        })
        .catch(error => {
          console.error('Error fetching contract details:', error)
        })
    },
  },
  mounted() {
    this.fetchEventDetails()
  }
}
</script>